import React, { Component } from 'react';
import { AppConstants } from '../../core/constants';
import { fixNumbers } from '../../core/utils';
import service from '../../core/service';
import * as yup from 'yup';
import { toast } from 'react-toastify';



interface IProps {

}

interface IState {
  str: string;
  anchorEl: null | HTMLElement;
  open: any,
  openAddModal: boolean;
  openActionModal: boolean;
  loading: boolean;
  transactionsList?: any;
  page: number;
  count: number;
  subject: string;
  errorsList:any;
  openEditModal: boolean;
  selectedItem:any;
  openConfirmModal:boolean;
  isChangingStage: boolean;
  stagesList:any;
  stage:any;
  filterModal:boolean;
  isFilterApplying: boolean;
  dealStagesList:Array<any>,
  dealStage:any,
  dealStatesList:Array<any>,
  dealState:any,
  to_date:any,
  from_date:any,
  rowsCountList:any,


}

export class DealsListController extends Component<IProps, IState> {

  datePickerRef: any;

  constructor(props: any) {
    super(props);
    this.datePickerRef = React.createRef();
  }

  state: IState = {
    str: "",
    anchorEl: null,
    open: false,
    openAddModal: false,
    openActionModal: false,
    filterModal:false,
    isFilterApplying: false,
    loading: false,
    transactionsList: [],
    page: 1,
    errorsList:[],
    subject: "",
    count: 6,
    stage:"",
    openEditModal: false,
    selectedItem:null,
    openConfirmModal: false,
    isChangingStage: false,
    stagesList:[],
    dealStage:null,
    dealStagesList:[],
    dealStatesList:[],
    dealState:null,
    to_date:"",
    from_date:"",
    rowsCountList:[6, 10, 50, 100],

  };
  handleClick = (event: React.MouseEvent<HTMLElement>) => {
    this.setState({ anchorEl: this.state.anchorEl ? null : event.currentTarget });
    this.setState({ open: this.state.anchorEl ? null : Boolean(event.currentTarget) });

  };
  emptyCount= () => {
    this.setState({ count: 6, page:1 });
  };
  emptyFromDate= () => {
    this.setState({ from_date: "", page:1 });
  };
  emptyToDate= () => {
    this.setState({ to_date: "", page:1 });
  };
  handleChangeFromDate = (value: any) => {
    this.setState({ from_date:value ? fixNumbers(value.format()) : null, page:1 })

  };
  handleChangeToDate = (value: any) => {
    this.setState({ to_date:value ? fixNumbers(value.format()) : null, page:1 });
  };
  paginationRowTimeOut: string | number | NodeJS.Timeout | undefined;
  handleCount = (value: any) => {
    this.setState({ count: value, page:1 });
    clearTimeout(this.paginationRowTimeOut);
    this.paginationRowTimeOut = setTimeout(() => {
      this.getDealsList()
    }, 800);
  }
  getDealsList = async () => {
    
    this.setState({ loading: true, filterModal: false, isFilterApplying: true })
    const { page, count, from_date, to_date, dealState, dealStage } = this.state;
    let parameters = {
      page: page ? page.toString() : "1",
      count: count ? count.toString() : "6",
      state_name: dealState ? dealState : null,
      stage_name : dealStage ? dealStage : null,
      from_date: from_date ? from_date : null,
      to_date: to_date ? to_date : null,

    }
    let url = new URL(`${AppConstants.base_url_api}lead/deal/${window.location.pathname.split("/")[2]}/data/`)
    for (const [key, value] of Object.entries(parameters)) {
      if (value) {
        url.searchParams.append(key, value)
      }
    }
    try {
      const response = await service.Deals.list(url.search);
      if (response) {
        this.setState({ transactionsList: response?.data?.data, loading:false })
      } else {
        this.setState({ loading: false })
      }
    } catch (error) {
      // throw error;
    }
    finally {
      this.setState({ isFilterApplying: false })
    }
  };
  paginationTimeOut: string | number | NodeJS.Timeout | undefined;
  handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
    this.setState({ page: value })
    clearTimeout(this.paginationTimeOut);
    this.paginationTimeOut = setTimeout(() => {
      this.getDealsList()
    }, 800);
  }

  handleRemove = (item:any) =>{
    this.setState({selectedItem: item, openConfirmModal: true});
  }
 async confirmDelete  () {
  const { selectedItem } = this.state;
    const response = await service.Deals.delete(selectedItem?.id);
    if (response) {
      if(response.status === 200){
        toast.success("با موفقیت حذف شد");
        this.setState({selectedItem:null, openConfirmModal: false});
        this.getDealsList();

      }
      else{
        toast.error("مشکلی پیش آمده‌است");
      }
    } else {
      this.setState({ loading: false, openConfirmModal: false });
      toast.error("مشکلی پیش آمده‌است");
    }
  }
  handleUpdate = (item:any) =>{
    this.setState({selectedItem: item, openEditModal: true, subject: item?.subject})

  }
  async sendUpdate () {
    const { subject, selectedItem } = this.state;
    const schema = yup.object({
        subject: yup.string().required(" عنوان اجباری می‌باشد"),
        });   
        try {
          await schema.validate({ subject }, { abortEarly: false });
          const response = await service.Deals.update( subject, selectedItem?.id );
            if (response) {
                if(response?.status === 200){
                    this.setState({ errorsList:[], openEditModal: false, subject:"", selectedItem:null });
                    this.getDealsList();
                    toast.success("با موفقیت ارسال شد");
                }
                else{
                    toast.error("مشکلی پیش آمده‌است");
                }
            } else {
                this.setState({ loading: false });
                toast.error("مشکلی پیش آمده‌است");

            }  
        } catch (err: any) {
          this.setState({ errorsList: err.inner  })
        }
  }
  async handleNewTransaction () {
    const { subject } = this.state;
    const schema = yup.object({
        subject: yup.string().required(" عنوان اجباری می‌باشد"),
        });   
        try {
          await schema.validate({ subject }, { abortEarly: false });
          const response = await service.Deals.create( subject );
            if (response) {
                if(response?.status === 200){
                    this.setState({ errorsList:[], openAddModal: false, subject:"" });
                    this.getDealsList();
                    toast.success("با موفقیت ارسال شد");
                }
                else{
                    toast.error("مشکلی پیش آمده‌است");
                }
            } else {
                this.setState({ loading: false });
                toast.success("با موفقیت ارسال شد");

            }  
        } catch (err: any) {
          this.setState({ errorsList: err.inner  })
        }
  }
  async handleChaneState (item:any){
    const { selectedItem } = this.state;
    const response = await service.Stage.list();
    if (response) {
      if(response.status === 200){
        this.setState({selectedItem:item, openEditModal: true,
           stagesList:response?.data?.data?.list});
      }
      else{
        toast.error("مشکلی پیش آمده‌است");
      }
    } else {
      this.setState({ loading: false, openEditModal: false });
      toast.error("مشکلی پیش آمده‌است");
    }
  }
  async handleChangeStage (){
    const { stage, selectedItem } = this.state;
    this.setState({ isChangingStage: true });
    const schema = yup.object({
        stage: yup.string().required(" انتخاب مرحله اجباری می‌باشد"),
        });   
        try {
          await schema.validate({ stage }, { abortEarly: false });
          const response = await service.Deals.changeStage( stage, window.location.pathname.split("/")[2], selectedItem?.id );
            if (response) {
                if(response?.status === 200){
                    this.setState({ errorsList:[], openEditModal: false, stage:"" });
                    this.getDealsList();
                    toast.success(response?.data?.message);
                }
                else{
                    toast.error(response?.data?.message)
                }
            } else {
                this.setState({ loading: false, openEditModal:false });
                toast.success("مشکلی پیش آمده‌است");

            }  
        } catch (err: any) {
          this.setState({ errorsList: err.inner  });
        }
        finally {
          this.setState({ isChangingStage: false });
        }
  }
  handleOpenFilterModal = () =>{
    const { filterModal }  = this.state;
    this.setState({ filterModal: !filterModal });
    this.getDealsState();
    this.getDealsStage();
  }
  getDealsStage= async () => {
    try {
      const response = await service.Stage.list();
      if (response) {
        if(response.status === 200){
          this.setState({ dealStagesList: response?.data?.data?.list })
        }
        else{
          toast.error("مشکلی پیش آمده‌است")
        }
      } else {
        toast.error("مشکلی پیش آمده‌است")
      }
    } catch (error) {
    }
  };
  getDealsState = async () => {
      try {
        const response = await service.Deals.statesList();
        if (response) {
          if(response.status === 200){
            this.setState({ dealStatesList: response?.data?.data?.list })
          }
          else{
            toast.error("مشکلی پیش آمده‌است")
          }
        } else {
          toast.error("مشکلی پیش آمده‌است")
        }
      } catch (error) {
      }
    };
}
export default DealsListController;